module.exports = __webpack_public_path__ + "img/url.7f4783dc.png";